module.exports = __webpack_public_path__ + "media/images/courses/courses-101110bae8b7914ece76523307511f84.png";